import { isNil, omitBy } from 'lodash';
import styled from 'styled-components';
import { TableCell, DateCell } from 'ui/tableCell';
import { JsonView } from 'ui/treeView';
import { formatPhoneNumber } from 'utils/phoneNumber';
import type { WhatsAppMessagesTableColumnData, WhatsAppReceived } from './types';

const StyledTableCell = styled(TableCell)<{ width?: string }>`
  ${({ width }) => width && `width: ${width};`}
`;

export const configureTableColumns = (): WhatsAppMessagesTableColumnData[] => {
  return [
    {
      name: 'User email',
      align: 'flex-start',
      value: 'email',
      RowCell: ({ row }) => <StyledTableCell width="15%">{row.email}</StyledTableCell>,
    },
    {
      name: 'Created',
      align: 'flex-start',
      value: 'createdAt',
      RowCell: ({ row }) => <DateCell timestamp={row.createdAt} />,
    },
    {
      name: 'WhatsApp Message Content',
      align: 'flex-start',
      value: 'text',
      sortable: false,
      width: 400,
      RowCell: ({ row }) => {
        const { typeName, ...rest } = omitBy(row.whatsAppMessage, isNil);
        return (
          <StyledTableCell width="50%">
            <JsonView src={rest ?? {}} collapseByDefault />
          </StyledTableCell>
        );
      },
    },
    {
      name: 'Sender Phone Number',
      align: 'flex-start',
      value: 'fromWhatsAppPhoneNumber',
      RowCell: ({ row }) => <TableCell>{formatPhoneNumber(row.fromWhatsAppPhoneNumber)}</TableCell>,
    },
    {
      name: 'Receiver Phone Number',
      align: 'flex-start',
      value: 'toWhatsAppPhoneNumber',
      RowCell: ({ row }) => <TableCell>{formatPhoneNumber(row.toWhatsAppPhoneNumber)}</TableCell>,
    },
  ];
};

export const whatsAppMessagesFilterFn = (whatsAppMessage: WhatsAppReceived, filter: string) => {
  if (whatsAppMessage.email?.toLowerCase().includes(filter.toLowerCase())) {
    return true;
  }

  if (whatsAppMessage.createdAt.includes(filter)) {
    return true;
  }

  return false;
};
